// extracted by mini-css-extract-plugin
export var deleteModal = "_dj-0";